var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGdriveIcoGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.23884 18.4772L3.25317 20.2654C3.46394 20.642 3.7669 20.9378 4.12259 21.1529C5.14142 19.833 5.85046 18.82 6.25009 18.1142C6.65555 17.3979 7.15392 16.2773 7.74518 14.7528C6.15171 14.5387 4.94421 14.4316 4.12268 14.4316C3.33412 14.4316 2.12662 14.5387 0.5 14.7528C0.5 15.1696 0.605387 15.5864 0.81616 15.9629L2.23884 18.4772V18.4772Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8779 21.1529C20.2337 20.9378 20.5367 20.642 20.7474 20.2655L21.1689 19.526L23.1845 15.9629C23.3913 15.5945 23.5003 15.1774 23.5005 14.7528C21.8645 14.5387 20.6592 14.4316 19.8846 14.4316C19.0521 14.4316 17.8467 14.5387 16.2686 14.7528C16.8528 16.2857 17.3446 17.4062 17.744 18.1142C18.1467 18.8284 18.858 19.8413 19.8779 21.1529V21.1529Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 7.22284C13.1793 5.76981 13.9916 4.64929 14.4375 3.86147C14.7966 3.22707 15.1919 2.21411 15.6231 0.822703C15.2674 0.607568 14.8591 0.5 14.4375 0.5H9.56351C9.14196 0.5 8.73371 0.621048 8.37793 0.822703C8.92652 2.41852 9.39209 3.55426 9.77446 4.22984C10.1971 4.97648 10.9391 5.97412 12.0005 7.22284Z",
    fill: "#757575"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2554 14.752H7.74555L4.12305 21.1521C4.47865 21.3672 4.88699 21.4748 5.30854 21.4748H18.6924C19.1139 21.4748 19.5224 21.3537 19.878 21.152L16.2555 14.752H16.2554Z",
    fill: "#757575"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 7.22231L8.37759 0.822266C8.02181 1.0374 7.71886 1.33314 7.50808 1.70968L0.81616 13.5418C0.609261 13.9102 0.500273 14.3274 0.5 14.752H7.74518L12.0002 7.22231H12.0001Z",
    fill: "#757575"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.838 7.62581L16.4919 1.70968C16.2812 1.33314 15.9782 1.0374 15.6225 0.822266L12 7.22241L16.2548 14.7521H23.4869C23.4869 14.3352 23.3815 13.9185 23.1707 13.5419L19.838 7.62581Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGdriveIcoGray);
export default __webpack_public_path__ + "static/media/gdriveIcoGray.4797bde94a089f0250f24e37582eebd4.svg";
export { ForwardRef as ReactComponent };